var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPlus = function SvgPlus(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.85 2.04a.8.8 0 0 0-.43.22.84.84 0 0 0-.26.52v8.34h-8.4a.8.8 0 0 0-.48.22.9.9 0 0 0-.24.4c-.02.07-.02.09-.02.22s0 .15.02.22c.04.15.12.28.24.4.14.13.3.2.48.22h8.4v8.46c.02.19.09.35.23.49.07.08.15.14.23.18l.06.03h.64l.06-.03c.08-.04.16-.1.23-.18.13-.14.21-.3.23-.49V12.8h8.4a.87.87 0 0 0 .67-.47c.03-.07.07-.2.07-.24v-.24a.76.76 0 0 0-.26-.5.82.82 0 0 0-.48-.22h-8.4V2.79a.84.84 0 0 0-.26-.52.8.8 0 0 0-.31-.19.9.9 0 0 0-.41-.03M2 11.97v.05-.1z"
  })));
};
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.6e74a9ab25f3976f5e23fde02e80db2a.svg";